import '.bl{position:absolute;}.ssr-plugin'
import '.gj{top:-36px;}.ssr-plugin'
import '.gk{left:1rem;}.ssr-plugin'
import '.gl{z-index:5;}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.g4{border-radius:10px;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { Card } from '@app/components/blocks/card/Card'
import { Title } from '@app/components/core/typography/Title'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import { Tag } from '@app/components/core/tag/Tag'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { pages } from '@app/util/links'
import defaultBanner from '@app/assets/defaultBanner.png'
import { expandImage, type StoredImage } from '@app/types/StoredImage'
import { useTranslations } from '@i18n/useLanguage'

export type ServiceProviderCardProps = {
  slug: string
  name?: string | null
  description?: string | null
  banner?: string | StoredImage | null
  avatar?: string
  types?: { name?: string | null; type?: string | null }[]
  style?: Style
}

export const ServiceProviderCard = ({
  slug,
  name,
  description,
  banner,
  avatar,
  types,
  style,
}: ServiceProviderCardProps) => {
  const t = useTranslations().app
  const cardBanner = expandImage(
    banner ?? defaultBanner,
    name ? `${name} ${t.common.banner}` : t.common.banner,
  )
  return (
    <styled.div style={style}>
      <Card
        image={cardBanner}
        imageStyle={{
          height: '12.5rem',
          borderTopRightRadius: '1.25rem',
          borderTopLeftRadius: '1.25rem',
          borderBottomRightRadius: '0',
          borderBottomLeftRadius: '0',
        }}
        to={pages.serviceProvider(slug)}
      >
        {/* Logo Overlay */}
        <div className="bl gj gk gl b5 v g4"
        >
          <Avatar
            shape="square"
            size="medium"
            image={avatar}
            labelSource={name?.charAt(0)}
            style={{ border: '1px solid var(--palette-blue-50)' }}
          />
        </div>

        {/* Service Provider Content */}
        <Column
          style={{ paddingTop: '1.5rem', justifyContent: 'space-between' }}
        >
          <div>
            {/* Title */}
            <Title.H4 style={{ marginBottom: '0.5rem' }}>{name}</Title.H4>

            {/* Description */}
            <Paragraph.Medium
              style={{
                color: 'var(--palette-blue-500)',
                marginBottom: '1.25rem',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {description}
            </Paragraph.Medium>
          </div>

          {/* Category Tag */}
          <Row gap="0.5rem" style={{ flexWrap: 'wrap' }}>
            {(types ?? []).map((spType, index) => {
              const label = (spType?.name ?? spType?.type ?? '').trim()

              if (!label) {
                return null
              }

              return (
                <Tag
                  key={`sp-type-${spType.type ?? spType.name ?? index}`}
                  variant="subtle"
                  size="small"
                  label={label}
                />
              )
            })}
          </Row>
        </Column>
      </Card>
    </styled.div>
  )
}
